// extracted by mini-css-extract-plugin
module.exports = {"Icon":"Icon--envMP"};